import { render, staticRenderFns } from "./GLYF_Amendment_Review.vue?vue&type=template&id=08b2ba4e&scoped=true"
import script from "./GLYF_Amendment_Review.vue?vue&type=script&lang=js"
export * from "./GLYF_Amendment_Review.vue?vue&type=script&lang=js"
import style0 from "./GLYF_Amendment_Review.vue?vue&type=style&index=0&id=08b2ba4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2ba4e",
  null
  
)

export default component.exports